import styled, { css } from 'styled-components';

import { getCurrentCountry } from '@wecasa/common/src/utils/country';
import { formatPrice } from '@wecasa/common/src/utils/formatting';

import { CONFIG_BY_COUNTRY } from '@wecasa/customer/src/constants/country-config';
import type { BasketState } from '@wecasa/customer/src/ducks/types';
import type { PricesResponse } from '@wecasa/customer/src/types/prices';

import { translate } from '@wecasa/i18n';

import type { MembershipOptIn } from '@wecasa/membership/src/types/membership';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';
import Skeleton from '@wecasa/web-ui/src/components/skeleton/skeleton';

import SelectablePriceCard, { type SelectablePriceCardProps } from '../selectable-price-card';

const t = translate('modals.membership_paywall.price_cards');

const StyledCard = styled(SelectablePriceCard)<{
  $height: 'md' | 'lg';
}>`
  ${({ $height }) => css`
    height: ${$height === 'lg' ? 105 : 85}px;
  `};
  margin-bottom: 20px;
`;

const StyledPrices = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

type SelectableCleaningStandardPriceCardProps = Pick<SelectablePriceCardProps, 'onPress'> & {
  duration: BasketState['duration'];
  prices: PricesResponse | undefined;
  isLoadingPrices: boolean;
  optInChoice?: MembershipOptIn;
};

const SelectableCleaningStandardPriceCard = ({
  duration,
  onPress,
  prices,
  isLoadingPrices,
  optInChoice,
}: SelectableCleaningStandardPriceCardProps) => {
  const currentCountry = getCurrentCountry();
  const showTaxReductions = CONFIG_BY_COUNTRY[currentCountry].isTaxCreditAvailable;

  const showPrice = !!duration;

  return (
    <StyledCard
      $height={showTaxReductions ? 'lg' : 'md'}
      isSelected={optInChoice === 'noMembership'}
      onPress={onPress}
      title={t('.standard.pay_without_club')}
      value='noMembership'
    >
      {showPrice && (
        <StyledPrices>
          {isLoadingPrices ? (
            <Skeleton linesWidth={showTaxReductions ? ['70px', '90px'] : ['70px']} />
          ) : (
            <>
              <Text.MDBold>{formatPrice(prices?.standard.after_tax.price)}</Text.MDBold>
              {showTaxReductions && (
                <>
                  <Text>{t('.cleaning.or_price', { priceBeforeITC: formatPrice(prices?.standard.total.price) })}</Text>
                  <Text.XXS>{t('.cleaning.before_itc')}</Text.XXS>
                </>
              )}
            </>
          )}
        </StyledPrices>
      )}
    </StyledCard>
  );
};

export default SelectableCleaningStandardPriceCard;
